import { useState, useEffect } from 'react'
/**
 * BackToTop — a circular button that appears after scrolling 400 px
 * and smoothly returns the user to the top of the page.
 */
export function BackToTop() {
  const [show, setShow] = useState(false)
  useEffect(() => {
    const fn = () => setShow(window.scrollY > 400)
    window.addEventListener('scroll', fn)
    return () => window.removeEventListener('scroll', fn)
  }, [])
  return show
    ? <button id="btt" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Back to top">↑</button>
    : null
}
